import { render } from "./CadastroPagar.vue?vue&type=template&id=4e74f611"
import script from "./CadastroPagar.vue?vue&type=script&lang=js"
export * from "./CadastroPagar.vue?vue&type=script&lang=js"

import "./CadastroPagar.vue?vue&type=style&index=0&id=4e74f611&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__